module.exports = "/images/icon_checkbox_checked.png?2af3b556665c021f2e8290346e5a92a3";